/* eslint-disable jsx-quotes */
import React from 'react';

import Portal from '../../Portal/Portal';

import './styles.css';

export default class ConfirmationModalPresentation extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { handleClickOutPortal, handleConfirm, message } = this.props;
        return (
            <Portal>
                <section className="portal">
                    <span
                        className="background-container"
                        onClick={handleClickOutPortal}
                    />
                    <div className="container-confirm">
                        <p>{message}</p>
                        <span className="container-line">
                            <button onClick={handleClickOutPortal}>Não</button>
                            <button onClick={handleConfirm}>Sim</button>
                        </span>
                    </div>
                </section>
            </Portal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/modals-components/ConfirmationModal/ConfirmationModalPresentation.js